import { BrowserRouter } from 'react-router-dom';
import Routes from './routes/routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DiefCfemProvider } from './contexts/DiefCfemContext';
import { useEffect } from 'react';
import { manutencaoDief } from './environments/environment';
import ManutencaoDief from './pages/Manutencao/ManutencaoDief';
import { useAuth } from 'hooks/useAuth';
import useA11yTracking from 'hooks/useA11yTracking';

const queryClient = new QueryClient();

export const APP_SYSTEM_PATH = '/dief';

function App() {
  const auth = useAuth();
  useA11yTracking();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      auth.setUrlToken(token);
    }
  }, []);

  return manutencaoDief.isAmbienteManutencao === 'true' ? (
    <ManutencaoDief />
  ) : (
    <QueryClientProvider client={queryClient}>
      <DiefCfemProvider>
        <Routes />
      </DiefCfemProvider>
    </QueryClientProvider>
  );
}

export default App;
